<template>
	<div id="content_body">
		<div class="container" >
			<div class="row">

				<div class="col-xl-12">
					<div class="card">
						<div class="card-header">
							{{$t('default.signPad')}}
						</div>
						<div class="card-body">
							<div class="form-row">
								<div class="col-md-3">
									<div class="form-group">
										<label>{{$t('signature.strokeType.label')}}</label>
										<select v-model="strokeType" class="form-control" >
											<option value="dash">Dash</option>
											<option value="circle">Circle</option>
											<option value="square">Square</option>
											<option value="triangle">Triangle</option>
											<option value="half_triangle">Half Triangle</option>
										</select>
									</div>
								</div>
								<div class="col-md-3">
									<div class="form-group">
										<label>{{$t('signature.line.label')}}</label>
										<select v-model="line" class="form-control" >
											<option v-for="n in 25" :key="'option-' + n" :value="n">
												{{ n }}
											</option>
										</select>
									</div>
								</div>
								<div class="col-md-3">
									<div class="form-group">
										<label>{{$t('signature.color.label')}}</label>
										<input type="color" v-model="color" class="form-control" />
									</div>
								</div>
								<div class="col-md-3">
									<div class="form-group">
										<label>{{$t('signature.backgroundColor.label')}}</label>
										<input type="color" v-model="backgroundColor" class="form-control" />
									</div>
								</div>
							</div>
							<div class="row">
								<div class="col-xl-7">
									<!-- :image.sync="image" -->
									<vue-drawing-canvas
										ref="VueCanvasDrawing"
										:image="localImage"
										:stroke-type="strokeType"
										:fill-shape="fillShape"
										:eraser="eraser"
										:lineWidth="line"
										:color="color"
										:background-color="backgroundColor"
										:background-image="backgroundImage"
										:watermark="watermark"
										saveAs="jpeg"
										:styles="{
											border: 'solid 1px #000',
											maxWidth:'100%'
										}"
										:lock="disabled"
										@mousemove="getCoordinate($event)"
									/>
								</div>
								<div class="col-xl-5">
									<img :src="image" style="border: solid 1px #000000" width="100%"/>
									<div class="form-row">
										<div class="col-md-6">
											<div class="form-group">
												<label>{{$t('signature.uploadBackgroundImage.label')}}</label>
												<b-form-file :lang="language" :placeholder="$t('default.form.file.placeholder')" :drop-placeholder="$t('default.form.file.placeholder')" @change="setImage($event)" accept="image/png, image/jpeg"/>
												<!-- <input type="file" @change="setImage($event)" class="form-control" accept="image/png, image/jpeg"/> -->
											</div>
										</div>
										<div class="col-md-6">
											<div class="form-group">
												<label>{{$t('signature.uploadWatermarkImage.label')}}</label>
												<b-form-file :lang="language" :placeholder="$t('default.form.file.placeholder')" :drop-placeholder="$t('default.form.file.placeholder')" @change="setWatermarkImage($event)" accept="image/png, image/jpeg"/>
												<!-- <input type="file" @change="setWatermarkImage($event)" class="form-control"  accept="image/png, image/jpeg"/> -->
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="card-footer">
							<div class="button-container">
								<!-- <button class="btn btn-success" @click="save">Save</button> -->
								<!-- <button @click="generateImage">Save Drawing</button> -->
								<button class="btn btn-success" type="button" @click.prevent="disabled = !disabled">
									<font-awesome-icon class="mr-1" :icon="['fas', 'unlock']" :title="$t('default.button.unlock')" v-if="!disabled"/>
									<font-awesome-icon class="mr-1" :icon="['fas', 'lock']" :title="$t('default.button.lock')" v-else/>
									
									<span v-if="!disabled">{{$t('default.button.unlock')}}</span>
									<span v-else>{{$t('default.button.lock')}}</span>
								</button>
								<button class="btn btn-warning" type="button" @click.prevent="$refs.VueCanvasDrawing.undo()">
									<font-awesome-icon class="mr-1" :icon="['fas', 'undo']" :title="$t('default.button.undo')"/>
									{{$t('default.button.undo')}}
								</button>
								<button class="btn btn-warning" type="button" @click.prevent="$refs.VueCanvasDrawing.redo()">
									<svg
										xmlns="http://www.w3.org/2000/svg"
										width="16"
										height="16"
										fill="currentColor"
										class="bi bi-arrow-clockwise"
										viewBox="0 0 16 16"
									>
										<path
											fill-rule="evenodd"
											d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z"
										/>
										<path
											d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z"
										/>
									</svg>
									{{$t('default.button.redo')}}
								</button>
								<button class="btn btn-primary" type="button" @click.prevent="$refs.VueCanvasDrawing.redraw()"
								>
									<font-awesome-icon class="mr-1" :icon="['fas', 'retweet']" :title="$t('default.button.retweet')"/>
									{{$t('default.button.retweet')}}
								</button>
								<button class="btn btn-danger" type="button" @click.prevent="$refs.VueCanvasDrawing.reset()">
									<font-awesome-icon class="mr-1" :icon="['fas', 'window-restore']" :title="$t('default.button.reset')"/>
									{{$t('default.button.reset')}}
								</button>

								<button class="btn btn-info" type="button" @click.prevent="eraser = !eraser">
									<span v-if="eraser">
										<font-awesome-icon class="mr-1" :icon="['fas', 'eraser']" :title="$t('default.button.eraser')"/>
										{{$t('default.button.eraser')}}
									</span>
									<span v-else>
										<svg
											xmlns="http://www.w3.org/2000/svg"
											width="16"
											height="16"
											fill="currentColor"
											class="bi bi-pencil"
											viewBox="0 0 16 16"
										>
											<path
												d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168l10-10zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207 11.207 2.5zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293l6.5-6.5zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325z"
											/>
										</svg>
										{{$t('default.button.draw')}}
									</span>
								</button>

								<button class="btn btn-info" type="button" @click.prevent="fillShape = !fillShape">
									<span v-if="fillShape">
										<font-awesome-icon class="mr-1" :icon="['fas', 'square']" :title="$t('default.button.fill')"/>
										{{$t('default.button.fill')}}
									</span>
									<span v-else>
										<svg
											xmlns="http://www.w3.org/2000/svg"
											width="16"
											height="16"
											fill="currentColor"
											class="bi bi-square"
											viewBox="0 0 16 16"
										>
											<path
												d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"
											/>
										</svg>
										{{$t('default.button.stroke')}}
									</span>
								</button>

							</div>
						</div>
					</div>
				</div>

			</div>

		</div>
	</div>
</template>
<script type="module">
	import VueDrawingCanvas from "vue-drawing-canvas/dist/vue-drawing-canvas.esm";

	export default {
		name: 'Signature',
		props: {
			user: {
				type: Object,
				required: false
			}, 
			currentImg: {
				type: String,
				required: false
			},
			strImg: {
				type: String,
				required: false
			},
		},
		components: {
			"vue-drawing-canvas": VueDrawingCanvas,
		},
		setup: () => {},
		data() {
			return {
				x: 0,
				y: 0,
				image: "",
				localImage:{},
				eraser: false,
				disabled: false,
				fillShape: false,
				line: 5,
				color: "#000000",
				strokeType: "dash",
				backgroundColor: "#FFFFFF",
				backgroundImage: null,
				watermark: {
					type: "Text", // "Text" or "Image"
					source: ``, // either Text or Image URL
					x: 200,
					y: 180,
					imageStyle: {
						width: 600,
						height: 400,
					},
					fontStyle: {
						width: 200,
						lineHeight: 48,
						color: "#FF0000",
						font: "bold 48px roboto",
						drawType: "fill", // "fill" or "stroke"
						textAlign: "left",
						textBaseline: "top",
						rotate: 0,
					},
				},
				language: this.$store.getters.language
			}
		},
		watch: {
			image: function (val) {
				// && this.user.imgSignature 
				if(this.user && val !== '')
					this.user.imgSignature = val
				// if(this.strImg && val !== '')
				// 	this.strImg = val
				console.log('hdhdhdh == ', val)
			}
		},
		methods: {
			generateImage(){
				// this.localImage = this.$refs.VueCanvasDrawing.save();
				if (this.$refs.VueCanvasDrawing.value) {
					this.localImage.value = this.$refs.VueCanvasDrawing.value.save();
					console.log("Saved image data:", this.localImage);
				}
			},
			async setImage(event) {
				let URL = window.URL;
				this.backgroundImage = URL.createObjectURL(event.target.files[0]);
				await this.$refs.VueCanvasDrawing.redraw();
			},
			async setWatermarkImage(event) {
				let URL = window.URL;
				this.watermark = {
					type: "Image",
					source: URL.createObjectURL(event.target.files[0]),
					x: 0,
					y: 0,
					imageStyle: {
						width: 600,
						height: 400,
					},
				};
				await this.$refs.VueCanvasDrawing.redraw();
			},
			getCoordinate(event) {
				let coordinates = this.$refs.VueCanvasDrawing.getCoordinates(event);
				this.x = coordinates.x;
				this.y = coordinates.y;
			},
		},
	}
</script>

<style scoped>
	.flex-row {
		display: flex;
		flex-direction: row;
	}
	.button-container {
		display: flex;
		flex-direction: row;
	}
	.button-container > * {
		margin-top: 5px;
		margin-right: 10px;
	}
</style>
